// extracted by mini-css-extract-plugin
export default {"productNameWrapper":"d78646158782"};